module.exports = __webpack_public_path__ + "02_mid_black.26c2c6af.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_mid_black.png
// module id = Q5kV
// module chunks = 0